module.exports = "/images/nato.svg?f8a87f52f01a249549b84253a12f2057";